import * as React from "react";

import "./feedback-form.scss";

import {makeChain, Link} from "@Common/react/cst2";

import {ContentArea} from "./content-area";


export const FeedbackForm = ({
    surveyId,
    onClose
}:{
    surveyId  : string,
    onClose   : () => void
}) => (
    makeChain<JSX.Element>()
    .then("onSelectFormCloseButton", ({}, next:Link<JSX.Element, (e:React.MouseEvent<HTMLDivElement>|React.KeyboardEvent<HTMLDivElement>) => void>) => next(
        e => {
            if ((e.target as HTMLElement).classList.contains("css-1gw3poj")) {
                onClose();
            }
        }
    ))
    .then(({onSelectFormCloseButton}) => (
        <div className="feedback-form-19p">
            <ContentArea backText="Back to All Services" onBack={onClose}>
                <div className="form" id={surveyId}
                    onClick={onSelectFormCloseButton}
                    onKeyPress={onSelectFormCloseButton}
                ></div>
            </ContentArea>
        </div>
    ))
    .run()
);